import { type RouteMeta } from "vue-router";

export interface MjfRouteMeta extends RouteMeta {
  requiresAuth?: boolean;
  isGuest?: boolean;
  allowDisplayInMobile?: boolean;
  autoLogout?: boolean;
  isLandingView?: boolean;
  hideLayout?: boolean;
  parentRoute?: RouteNames;
}

export enum RouteNames {
  SplashTransition = "SplashTransition",
  Root = "Root",
  Auth = "Auth",

  Login = "Login",
  ForgotPassword = "ForgotPassword",
  ResetPassword = "ResetPassword",
  Registration = "Registration",
  RegistrationPassword = "RegistrationPassword",
  GoogleAuthenticator = "GoogleAuthenticator",
  SSOLogin = "SSOLogin",
  SSOLoginFailed = "SSOLoginFailed",
  ImpersonateLogin = "ImpersonateLogin",
  IdpLogin = "IdpLogin",

  AllSubscriptions = "AllSubscriptions",
  Dashboard = "Dashboard",
  ImpactCenter = "ImpactCenter",
  ImpactCenterPrint = "ImpactCenterPrint",
  UsageExplorer = "UsageExplorer",
  Billing = "Billing",
  Topology = "Topology",
  Security = "Security",
  Users = "Users",
  SupportContacts = "Contacts",
  Settings = "Settings",
  NotificationCenter = "NotificationCenter",
  JPDs = "JPDs",
  Licenses = "Licenses",
  AuthenticatedRelease = "AuthenticatedRelease",
  SupportTickets = "SupportTickets",
  ThreatIntelligence = "ThreatIntelligence",
  QuickUpgrade = "QuickUpgrade",
  ActivityLog = "AuditLogs",
  Sandbox = "Sandbox",

  ErrorNotFound = "ErrorNotFound",
  Maintenance = "Maintenance",
  AppNeedUpdate = "AppNeedUpdate",
  ErrorNetwork = "ErrorNetwork",

  Redirect = "Redirect",
  RedirectReactivateServer = "RedirectReactivateServer",

  LoginBeforeUpgrade = "LoginBeforeUpgrade",

  LandingPlatformSSODisabled = "LandingPlatformSSODisabled",
  Partnerships = "partnerships",
  Partner = "Partner",
  Partners = "Partners",

  MarketplacePurchase = "MarketplacePurchase",
}
